import { defineStore } from "pinia";
import { computed, ref } from "vue";

import { ContentStructureSection } from "@/models/content-structure.model";
import { LibraryFile } from "@/models/files.model";
import { SectionFile } from "@/models/product-section.model";
import { ProductItem } from "@/models/product.model";
import {
  ProductToAttachFile,
  SectionToAttachFile
} from "@/models/store/ui-state/attach-file.model";

export const useUIFilesStore = defineStore("uiFiles", () => {
  const fileForDisplay = ref<LibraryFile | null>(null);
  const openFileSidebar = (file: LibraryFile) => {
    fileForDisplay.value = file;
  };
  const closeFileSidebar = () => {
    fileForDisplay.value = null;
  };

  const fileForRenaming = ref<LibraryFile | null>(null);
  const isRenameAttachmentPopupOpen = computed<boolean>(() => {
    return !!fileForRenaming.value;
  });
  const openRenameAttachmentModal = (file: LibraryFile) => {
    fileForRenaming.value = file;
  };
  const closeRenameAttachmentModal = () => {
    fileForRenaming.value = null;
  };

  const fileToRemoveLink = ref<SectionFile | null>(null);
  const isRemoveAttachmentPopupOpen = computed<boolean>(() => {
    return !!fileToRemoveLink.value;
  });
  const openRemoveAttachmentModal = (file: SectionFile) => {
    fileToRemoveLink.value = file;
  };
  const closeRemoveAttachmentModal = () => {
    fileToRemoveLink.value = null;
  };

  const fileForNewVersion = ref<SectionFile | LibraryFile | null>(null);
  const isFileVersionModalOpen = computed<boolean>(() => {
    return !!fileForNewVersion.value;
  });
  const openAttachmentVersionModal = (file: SectionFile | LibraryFile) => {
    fileForNewVersion.value = file;
  };
  const closeAttachmentVersionModal = () => {
    fileForNewVersion.value = null;
  };

  const fileAttachmentType = ref<number | null>(null);

  const sectionToAttachFile = ref<ContentStructureSection | null>(null);
  const productToAttachFile = ref<ProductItem | null>(null);
  const isAttachFileModalOpen = computed<boolean>(() => {
    return !!sectionToAttachFile.value || !!productToAttachFile.value;
  });

  const openAttachFileModal = (
    params: ProductToAttachFile | SectionToAttachFile
  ) => {
    if ((params as SectionToAttachFile).section) {
      sectionToAttachFile.value = (params as SectionToAttachFile).section;
    }
    if (
      (params as ProductToAttachFile).product &&
      (params as ProductToAttachFile).attachmentType
    ) {
      productToAttachFile.value = (params as ProductToAttachFile).product;
      fileAttachmentType.value = (params as ProductToAttachFile).attachmentType;
    }
  };
  const closeAttachFileModal = () => {
    sectionToAttachFile.value = null;
    productToAttachFile.value = null;
    fileAttachmentType.value = null;
  };

  return {
    fileForDisplay,
    openFileSidebar,
    closeFileSidebar,
    fileForRenaming,
    isRenameAttachmentPopupOpen,
    openRenameAttachmentModal,
    closeRenameAttachmentModal,
    isRemoveAttachmentPopupOpen,
    fileToRemoveLink,
    openRemoveAttachmentModal,
    closeRemoveAttachmentModal,
    fileForNewVersion,
    isFileVersionModalOpen,
    openAttachmentVersionModal,
    closeAttachmentVersionModal,
    fileAttachmentType,
    sectionToAttachFile,
    productToAttachFile,
    isAttachFileModalOpen,
    openAttachFileModal,
    closeAttachFileModal
  };
});
